export default __webpack_public_path__ + "static/media/user.cacec522.svg";